/* Cabal · agregar rápido al carrito usando el cart drawer de Dawn */
(function () {
  function drawer() { return document.querySelector('cart-drawer'); }

  function updateCount() {
    fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart.js' : '/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cs-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
      })
      .catch(function () {});
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cs-add]');
    if (btn) {
      e.preventDefault();
      var label = btn.textContent;
      btn.classList.add('is-loading');
      var d = drawer();
      var body = { items: [{ id: Number(btn.dataset.csAdd), quantity: 1 }] };
      if (d && d.getSectionsToRender) {
        body.sections = d.getSectionsToRender().map(function (s) { return s.id; });
        body.sections_url = window.location.pathname;
      }
      fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          btn.classList.remove('is-loading');
          if (res.status) {
            btn.textContent = res.description || 'Sin stock';
            setTimeout(function () { btn.textContent = label; }, 2500);
            return;
          }
          btn.textContent = 'Agregado';
          setTimeout(function () { btn.textContent = label; }, 1600);
          if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cabal-quick-add', cartData: res });
          }
          if (d && res.sections) {
            var item = res.items ? res.items[0] : res;
            item.sections = res.sections;
            d.renderContents(item);
            d.classList.remove('is-empty');
          } else {
            window.location = (window.routes && window.routes.cart_url) || '/cart';
          }
          updateCount();
        })
        .catch(function () {
          btn.classList.remove('is-loading');
          window.location = '/cart';
        });
      return;
    }

    var bag = e.target.closest('[data-cs-open-cart]');
    if (bag && drawer()) {
      e.preventDefault();
      drawer().open(bag);
    }

    var tab = e.target.closest('[data-cs-tab]');
    if (tab) {
      var root = tab.closest('[data-cs-tabs]');
      root.querySelectorAll('[data-cs-tab]').forEach(function (t) { t.setAttribute('aria-selected', t === tab); });
      root.querySelectorAll('[data-cs-panel]').forEach(function (p) { p.hidden = p.dataset.csPanel !== tab.dataset.csTab; });
    }
  });

  if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, updateCount);
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) subscribe(PUB_SUB_EVENTS.cartUpdate, updateCount);
    });
  }
})();

/* Verificación de folio (formularios con data-cs-verify) */
document.addEventListener('submit', function (e) {
  var form = e.target.closest('[data-cs-verify]');
  if (!form) return;
  e.preventDefault();
  var msg = form.querySelector('[data-cs-msg]');
  var folio = (form.querySelector('input').value || '').replace(/\D/g, '');
  function say(t) { if (msg) { msg.hidden = false; msg.textContent = t; } }
  if (!folio) return say('Escribe el número de folio: solo dígitos.');
  var url = (form.dataset.csVerify || '/pages/folio/') + encodeURIComponent(folio);
  say('Buscando folio ' + folio + '…');
  fetch(url, { method: 'HEAD' })
    .then(function (r) {
      if (r.ok) window.location.href = url;
      else say('El folio ' + folio + ' no coincide con ningún pedido. Revisa los dígitos o escríbenos por WhatsApp.');
    })
    .catch(function () { window.location.href = url; });
});
